import * as React from "react";
import { Footer } from '../../component/layout/Footer';
import { Navigation } from '../../component/layout/Navigation';
import {RouteComponentProps} from "react-router";
import {IReadOrganizationResponse} from "../../core/api/organization/response/ReadOrganizationResponse";
import {OrganizationApiService} from "../../core/api/organization/OrganizationApiService";

interface IProps extends RouteComponentProps {
    componentName?: string;
}

interface IState {
    data: IReadOrganizationResponse;
    params: any;
}

export class VillageOrganizationDetail extends React.Component<IProps, IState> {

    private readonly apiService = new OrganizationApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            data: {} as IReadOrganizationResponse,
            params: this.props.match.params
        }


    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="village-org-detail-page" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 vo-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Organisasi Desa</h1>
                                <div className="hs-line-4 font-alt black">Informasi organisasi yang terdapat di desa Sanur Kauh</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Informasi Desa&nbsp;/&nbsp;Organisasi Desa</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row">
                            <div className="col-sm-10 col-sm-offset-1">
                                <div className="blog-item mb-80 mb-xs-40">
                                    <div className="blog-item-body">
                                        <div className="blog-item">
                                            <div className="blog-item-date">
                                                <img src={this.state.data.documentationImage} />
                                            </div>
                                            <h2 className="blog-item-title font-alt">
                                                {this.state.data.name}
                                            </h2>
                                            <hr />
                                            <div className="alt-service-grid">
                                                <div className="row multi-columns-row">
                                                    <div className="col-sm-4">
                                                        <div className="alt-service-item">
                                                            <div className="alt-service-icon"><i className="fa fa-user-o" /></div>
                                                            <h3 className="alt-services-title font-alt">Ketua</h3>
                                                            {this.state.data.leader}</div>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <div className="alt-service-item">
                                                            <div className="alt-service-icon"><i className="fa fa-address-book-o" /></div>
                                                            <h3 className="alt-services-title font-alt">Informasi Kontak</h3>
                                                            {this.state.data.phoneNumber}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <p>
                                            {this.state.data.description}
                                        </p>

                                        <div className="mb-80 mb-xs-40">
                                            <h4 className="blog-page-title font-alt">Struktur Organisasi</h4>
                                            <div className="text-center">
                                                <img src={this.state.data.structureImage} />
                                            </div>
                                            
                                        </div>

                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        

                    </div>
                </section>

                <Footer />
            </div>
        );
    }

    private fetchData = () => {
        this.apiService.readVillageOrganization(this.state.params.detail)
            .then((response: any) => {
                this.setState({
                    data: response.result
                })
            }).catch((error) => {
            this.setState({
                data: {} as IReadOrganizationResponse
            })
        })
    }

}


// WEBPACK FOOTER //
// ./src/screen/village-organization/VillageOrganizationDetail.tsx